<div class="container-fluid bg-fondo p-5">
    <div class=" justify-content-center text-center">
        <p>Para ceder el cupo, debes </p>
        <p>ingresar los siguientes datos:</p>
    </div>
    <div class="row justify-content-center">
        <form [formGroup]="forma" (ngSubmit)="registrar()" class="mt-3 example-form">
            <div class="row justify-content-center">
                <div class="form-group example-full-width" [ngClass]="{ 'text-danger': name.invalid && name.touched }">
                    <label class="col-form-label col-form-label-sm">Nombre y apellido</label>
                    <input
                        type="text"
                        class="form-control custom"
                        formControlName="name"
                        [imask]="nameMask">
                    <div *ngIf="name.errors && (name.dirty || name.touched)">
                        <span *ngIf="name.errors.required">Requerido</span>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="form-group example-full-width" [ngClass]="{ 'text-danger': email.invalid && email.touched }">
                    <label class="col-form-label col-form-label-sm">Correo electrónico</label>
                    <input
                        type="email"
                        class="form-control custom"
                        [pattern]="emailPattern"
                        formControlName="email" onkeypress="return event.charCode != 32">
                    <div *ngIf="email.errors && (email.dirty || email.touched)">
                        <span *ngIf="email.errors.required">Requerido</span>
                        <span *ngIf="email.errors.pattern || email.errors.email ">Formato email incorrecto</span>
                    </div>
                 </div>
            </div>
            <div class="row justify-content-center">
                <button type="button" class="btn btn-primary font-weight-bold m-2" title="Volver" [disabled]="formSubmitted" (click)="onBack()">
                    <i class="fas fa-arrow-left"></i>
                    Volver
                </button>
                <button type="submit" class="btn btn-primary font-weight-bold m-2" title="Enviar" [disabled]="formSubmitted">
                    <i class="fas fa-paper-plane"></i>
                    Enviar
                </button>
            </div>
        </form>
    </div>
    <ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
        <p class='color-spinner-text'>Cargando... </p>
    </ngx-spinner>
</div>
